var pubkey = `-----BEGIN PGP PUBLIC KEY BLOCK-----
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=z2eH
-----END PGP PUBLIC KEY BLOCK-----
`;

var svc = {
    part1: 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCrVWQLtVGs+hy6DZoZr5O9kRt3AQzI/F4dNs30VUQCQGU9W/Xr6mBsROJa6jwSVVYa1/EE9VaFrIUfkoUk4h9LKLKe',
    part2: null,

    set: function (str: any) {
        var self = this;
        self.part2 = str;
    },
    get: function () {
        return pubkey;
    }
};

export default svc;
